import SchoolListHeader from "./SchoolListHeader"

export default  SchoolListHeader;
